module.exports = __webpack_public_path__ + "static/media/Crown .2a60fad8.svg";